//
import { ModuleLayout } from '@/components/reusable_components/next'
import SlGroundSellerSaleView from '@/views/Sale/SlGroundSeller/SlGroundSellerSale'

//
export default {
  path: 'ground_seller_sale',
  component: ModuleLayout,
  children: [
    {
      path: '',
      name: 'sl-ground-sellers-sale',
      component: SlGroundSellerSaleView,
    },
  ],
  meta: {
    title: 'Ventas de vendedores en terreno',
  },
}
